'use client'

import { useState } from 'react'

export type OpenOptions = {
  closeOnOpen?: boolean
}

export const useDialog = <T extends string>() => {
  const [dialogs, setDialogs] = useState<Record<T, boolean>>(
    {} as Record<T, boolean>,
  )

  const isOpen = (key: T) => dialogs?.[key] || false

  const open = (key: T, { closeOnOpen = false }: OpenOptions = {}) => {
    setDialogs(prev => {
      if (closeOnOpen) {
        return { [key]: true } as Record<T, boolean>
      }

      return { ...prev, [key]: true }
    })
  }

  const close = (key: T) => {
    setDialogs(prev => ({ ...prev, [key]: false }))
  }

  const closeHandler = (key: T) => () => {
    close(key)
  }

  const closeAll = () => {
    setDialogs({} as Record<T, boolean>)
  }

  const toggle = (key: T) => {
    setDialogs(prev => ({ ...prev, [key]: !(prev[key] || false) }))
  }

  return {
    isOpen,
    open,
    close,
    closeHandler,
    closeAll,
    toggle,
  }
}
